import { createReducer } from "@reduxjs/toolkit";
import { LOAD_ATTACHMENTS } from "actions/types";

const initialState = [];
const attachmentsReducer = createReducer(initialState, {
  [LOAD_ATTACHMENTS]: (state, action) => {
    state = [...action.payload];
    return state;
  },
});

export default attachmentsReducer;
